import { makeStyles, Theme } from "@material-ui/core";

const useStyles = makeStyles((theme: Theme) => ({
  header: {
    background: "linear-gradient(135deg, #0F172A 0%, #1E293B 100%)",
    borderTopLeftRadius: 20,
    borderTopRightRadius: 20,
    boxShadow: "0 10px 30px -5px rgba(0, 0, 0, 0.05)",
    "& .MuiTableCell-root": {
      borderRight: "1px solid rgba(255, 255, 255, 0.1)",
      padding: "16px",
      [theme.breakpoints.down("sm")]: {
        padding: "10px 8px",
      },
    },
  },
  header__title: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100%",
    color: "#FFFFFF",
    fontWeight: 800,
    letterSpacing: "0.03em",
    fontSize: "0.95rem",
    [theme.breakpoints.down("sm")]: {
      fontSize: "0.75rem",
    },
  },
  
  // Compact Month Selector Pill for Table Calendar
  header__filterMonth: {
    backgroundColor: "rgba(255, 255, 255, 0.12)",
    backdropFilter: "blur(8px)",
    border: "1px solid rgba(255, 255, 255, 0.25)",
    borderRadius: 30,
    width: 160,
    minWidth: 150,
    margin: "0 auto",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    padding: "6px 16px",
    transition: "all 0.25s ease",
    boxShadow: "0 4px 14px rgba(0, 0, 0, 0.15)",
    "&:hover": {
      backgroundColor: "rgba(255, 255, 255, 0.22)",
      borderColor: "rgba(255, 255, 255, 0.4)",
      transform: "translateY(-1px)",
    },
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      minWidth: "100%",
      padding: "6px 10px",
    },
    "& >h6": {
      color: "#FFFFFF",
      fontWeight: 800,
      textAlign: "center",
      fontSize: "0.9rem",
      flexGrow: 1,
      [theme.breakpoints.down("sm")]: {
        fontSize: "0.8rem",
      },
    },
    "& >svg": {
      color: "#818CF8",
      fontSize: 20,
    },
  },

  formControl: {
    width: 160,
    margin: "0 auto",
  },

  table_container: {
    maxHeight: 500,
    borderBottomLeftRadius: 20,
    borderBottomRightRadius: 20,
    boxShadow: "0 10px 30px -5px rgba(0, 0, 0, 0.05), 0 4px 12px rgba(0, 0, 0, 0.03)",
    border: "1px solid #E2E8F0",
    borderTop: "none",
  },
  table: {
    minWidth: 600,
    [theme.breakpoints.down("sm")]: {
      minWidth: 480,
    },
  },
  status: {
    display: "inline-flex",
    alignItems: "center",
    gap: 6,
    padding: "4px 12px",
    borderRadius: 100,
    fontSize: "0.825rem",
    fontWeight: 700,
  },
  statusSuccess: {
    backgroundColor: "#F0FDF4",
    color: "#166534",
    border: "1px solid #BBF7D0",
  },
  statusMissed: {
    backgroundColor: "#FEF2F2",
    color: "#991B1B",
    border: "1px solid #FECACA",
  },
  status_checkIcon: {
    color: "#16A34A",
    fontSize: 16,
  },
  status_clearIcon: {
    color: "#DC2626",
    fontSize: 16,
  },

  // Styled Dropdown Menu
  menu_listMonth: {
    "& .MuiPaper-root": {
      borderRadius: 16,
      backgroundColor: "#FFFFFF",
      boxShadow: "0 12px 32px rgba(15, 23, 42, 0.18)",
      border: "1px solid #E2E8F0",
      overflowX: "hidden",
      overflowY: "auto",
      padding: "6px 4px",
      marginTop: 8,
      width: 180,
      maxHeight: 280,
    },
    "& .MuiList-root": {
      padding: 0,
    },
    "& .MuiMenuItem-root": {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      borderRadius: 8,
      margin: "2px 4px",
      fontWeight: 600,
      fontSize: "0.9rem",
      color: "#334155",
      transition: "all 0.15s ease",
      "&:hover": {
        backgroundColor: "#F1F5F9",
        color: "#2563EB",
      },
      "&.Mui-selected": {
        backgroundColor: "#EFF6FF !important",
        color: "#2563EB !important",
        fontWeight: 800,
      },
    },
  },
  mobileCard: {
    backgroundColor: "#FFFFFF",
    borderRadius: 16,
    padding: "16px 18px",
    border: "1px solid #E2E8F0",
    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.02)",
    transition: "all 0.25s ease",
    cursor: "pointer",
    "&:active": {
      transform: "scale(0.98)",
      backgroundColor: "#F8FAFC",
    },
  },
  rowClickable: {
    cursor: "pointer",
    transition: "background-color 0.2s ease",
    "&:hover": {
      backgroundColor: "#F1F5F9 !important",
    },
  },
}));

export default useStyles;
